import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.StatementCandidatesForAccountReceivable.IRequest;
type Response = Api.Finance.AccountReceivable.StatementCandidatesForAccountReceivable.IResponse;
type Headers = Api.Finance.AccountReceivable.StatementCandidatesForAccountReceivable.IHeaders;
const url = '/api/Finance/AccountReceivable/:id/StatementCandidates';
export default async function accountReceivableStatementCandidatesFindApi(
  id: number,
  query?: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { id }, query),
    headers: getDefaultHeaders(),
  });
}
